
export const BASE_URL = "http://localhost:3059";
export const SUBDOMAIN_TAIL = 'sites.contentsimi.com'